import { Link } from "react-router-dom";
import { ROUTES } from "../routes";
import styles from "./Handoff.module.css";

function formatFinishedAt(isoString) {
    return new Date(isoString).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

function Handoff({ learningJourneyId, view }) {
    const { headline, goal, changed, edge, first_move, finished_at } = view.view_data;

    return (
        <div className={styles.container}>
            <div className={styles.hero}>
                {goal && <p className={styles.premise}>{goal}</p>}
                <h1 className={styles.headline}>{headline}</h1>
            </div>

            {changed?.length > 0 && (
                <ul className={styles.changed}>
                    {changed.map((line, i) => (
                        <li key={i}>{line}</li>
                    ))}
                </ul>
            )}

            {(first_move || edge) && (
                <div className={styles.move}>
                    {first_move && (
                        <>
                            <p className={styles.moveLabel}>Your first move</p>
                            <p className={styles.firstMove}>{first_move}</p>
                        </>
                    )}
                    {edge && <p className={styles.edge}>{edge}</p>}
                </div>
            )}

            <div className={styles.exits}>
                <Link to={`/t/${learningJourneyId}/plan`} className={styles.exitLink}>
                    View your roadmap
                </Link>
                <span className={styles.exitDivider}>·</span>
                <Link to={ROUTES.ROOT} className={styles.exitLink}>
                    Start a new journey
                </Link>
            </div>

            {finished_at && (
                <p className={styles.finishedAt}>Finished {formatFinishedAt(finished_at)}</p>
            )}
        </div>
    );
}

export default Handoff;
